import { store } from "../../store";
import { billAdded, billUpdated, billRemoved } from "../../ReduxSlices/Bills/billSlice";
import subscribeToCoreUpdates from "../core_updates_channel";

let unsubscribeBills = null; // store the unsubscribe function

export const initializeBillSubscription = () => {
  if (unsubscribeBills) return; // already subscribed

  // Use a unique module key for this subscription
  unsubscribeBills = subscribeToCoreUpdates("bills", {
    "bill.created": (data) => {
     // console.log("📡 bill.created:", data);
      store.dispatch(billAdded(data));
    },
    "bill.updated": (data) => {
      // console.log("📡 bill.updated:", data);
      store.dispatch(billUpdated(data));
    },
    "bill.deleted": (data) => {
      // console.log("📡 bill.deleted:", data);
      store.dispatch(billRemoved(data.id));
    },
  });

  // console.log("✅ Bill subscription initialized");
};

export const unsubscribeBillSubscription = () => {
  if (unsubscribeBills) {
    unsubscribeBills(); // call the unsubscribe function
    unsubscribeBills = null;
    // console.log("🔌 Bill subscription removed");
  }
};